module.exports = __webpack_public_path__ + "assets/img/thumb-AuditCover.a40efc86.jpg";